"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialSaveHelper = void 0;
const component_1 = require("@front/components/site-menu/component");
class TutorialSaveHelper {
    static async handleSubmit(event) {
        if (this.saving) {
            console.warn('[tutorial form] duplicate save ignored while request is in progress');
            event.preventDefault();
            return;
        }
        console.log('[tutorial form] save handler entered', { tutorialId: this.tutorialId });
        event.preventDefault();
        const isValid = TutorialSaveHelper.validate.call(this);
        console.log('[tutorial form] save validation result', isValid);
        if (!isValid) {
            return;
        }
        this.saving = true;
        try {
            this.loading = true;
            const payload = TutorialSaveHelper.buildPayload.call(this);
            const isEdit = !!this.tutorialId;
            const endpoint = isEdit ? 'tutorial.update' : 'tutorial.create';
            const routeParams = isEdit ? { id: this.tutorialId } : undefined;
            const method = isEdit ? 'put' : 'post';
            console.log('[tutorial form] sending save request', { method: method.toUpperCase(), endpoint, routeParams });
            const response = await this.apiService.back[method](endpoint, payload, { routeParams });
            console.log('[tutorial form] save response', { success: response === null || response === void 0 ? void 0 : response.success, error: response === null || response === void 0 ? void 0 : response.error });
            if (response && response.success) {
                this.notifyService.notify(isEdit ? 'tutorial.updated'.t() : 'tutorial.created'.t(), 'info');
                component_1.SiteMenu.goto.bind(this)('/tutorial/list');
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.saveFailed'.t());
            }
        }
        catch (error) {
            console.error('Failed to save tutorial:', error);
            this.popupService.error('tutorial.saveFailed'.t());
        }
        finally {
            this.loading = false;
            this.saving = false;
        }
    }
    static validate() {
        var _a, _b, _c;
        if (!((_a = this.form.name) === null || _a === void 0 ? void 0 : _a.trim())) {
            this.popupService.error('tutorial.validation.nameRequired'.t());
            return false;
        }
        if (!this.steps || this.steps.length === 0) {
            this.popupService.error('tutorial.validation.stepsRequired'.t());
            return false;
        }
        for (let i = 0; i < this.steps.length; i++) {
            const step = this.steps[i];
            if (!((_b = step.title) === null || _b === void 0 ? void 0 : _b.trim())) {
                this.popupService.error(`${'tutorial.validation.stepTitleRequired'.t()}`.replace('{index}', (i + 1).toString()));
                return false;
            }
            if (step.sections.length === 0) {
                this.popupService.error(`${'tutorial.validation.stepSectionsRequired'.t()}`.replace('{index}', (i + 1).toString()));
                return false;
            }
            for (let j = 0; j < step.sections.length; j++) {
                if (!((_c = step.sections[j].title) === null || _c === void 0 ? void 0 : _c.trim())) {
                    this.popupService.error(`${'tutorial.validation.sectionTitleRequired'.t()}`.replace('{stepIndex}', (i + 1).toString()).replace('{sectionIndex}', (j + 1).toString()));
                    return false;
                }
            }
        }
        return true;
    }
    // Payload matching the backend expectation
    static buildPayload() {
        var _a, _b, _c;
        const payload = {
            name: this.form.name,
            description: this.form.description,
            introText: this.form.introText,
            tutorialGoal: this.form.tutorialGoal,
            expireAt: this.form.expireAt || null,
            categoryId: this.form.categoryId,
            active: this.form.active,
            publish: this.publish,
            source: this.form.source,
            logo: this.form.logo || null,
            sourceFile: this.form.sourceFile || null,
            scanPagesFrom: (_a = this.form.scanPagesFrom) !== null && _a !== void 0 ? _a : null,
            scanPagesTo: (_b = this.form.scanPagesTo) !== null && _b !== void 0 ? _b : null,
            hours: (_c = this.form.hours) !== null && _c !== void 0 ? _c : null
        };
        if (this.onboardingAttached) {
            payload.onboardingPayload = this.onboardingAttached;
        }
        if (this.form.avatar) {
            payload.avatar = this.form.avatar;
        }
        payload.steps = (this.steps || []).map((step, stepIndex) => {
            const stepPayload = {
                title: step.title || '',
                description: step.description || '',
                order: stepIndex + 1,
                sections: (step.sections || []).map((section, sectionIndex) => {
                    const sectionPayload = {
                        title: section.title || '',
                        description: section.description || '',
                        prompt: section.prompt || '',
                        order: sectionIndex + 1,
                        knowledgeIds: section.knowledgeIds || [],
                        todoItems: section.todoItems || [],
                        screenshot: section.screenshot || null,
                        video: section.video || null,
                        screenshotMini: section.screenshotMini || null,
                        videoMini: section.videoMini || null,
                        tutorialSectionFiles: section.tutorialSectionFiles || [],
                        sourceText: section.sourceText || '',
                        formData: section.formData || '',
                        sourcePages: (section.sourcePagesFrom != null && section.sourcePagesTo != null)
                            ? [section.sourcePagesFrom, section.sourcePagesTo]
                            : []
                    };
                    // Include section ID if it exists (for updates)
                    if (section.id) {
                        sectionPayload.id = section.id;
                    }
                    return sectionPayload;
                })
            };
            // Include step ID if it exists (for updates)
            if (step.id) {
                stepPayload.id = step.id;
            }
            return stepPayload;
        });
        return payload;
    }
}
exports.TutorialSaveHelper = TutorialSaveHelper;
